import { Outlet } from "react-router";
import { Header } from "./header";
import { IdleTimeout } from "./idle-timeout";

export function Layout() {
  return (
    // Constrain the authenticated app to the viewport (h-screen +
    // overflow-hidden) so the normal-flow Header (incl. impersonation banner)
    // and the content share one screen instead of stacking past it. The
    // content area takes the remaining flex height (min-h-0 flex-1) and owns
    // its own scroll, so ordinary sibling/admin/staff pages still scroll while
    // an h-full page (e.g. the yard layout) resolves against a bounded height.
    <div className="flex h-screen flex-col overflow-hidden bg-gray-50">
      {/* Auto sign-out on inactivity (authenticated users only) */}
      <IdleTimeout />

      {/* Header */}
      <Header />

      {/* Content */}
      <div className="min-h-0 flex-1 overflow-y-auto overscroll-none">
        <Outlet />
      </div>
    </div>
  );
}
